import {useCallback, useState} from 'react'
import {EMPTY_STATE, LOCAL_STORAGE_KEY} from './UserRegistrationModalForm.constants'

const getDefaultValuesFromLocalStorage = () => {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (saved) {
      const parsed = JSON.parse(saved)
      if (parsed && typeof parsed === 'object') {
        return parsed as typeof EMPTY_STATE
      }
    }

    localStorage.removeItem(LOCAL_STORAGE_KEY)
  } catch (e) {
    console.error('Error retrieving saved state from local storage:', e)
  }

  return EMPTY_STATE
}

export const useInputValues = () => {
  const [state, setState] = useState(getDefaultValuesFromLocalStorage)

  const handleChange = <T extends keyof typeof EMPTY_STATE>(
    name: T,
    value: (typeof EMPTY_STATE)[T],
  ) => {
    setState({...state, [name]: value})
  }

  const saveStateToLocalStorage = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({...state, name: state.name.trim()}))
  }

  const resetState = useCallback(() => {
    setState(getDefaultValuesFromLocalStorage())
  }, [])

  return {
    state,
    handleChange,
    saveStateToLocalStorage,
    resetState,
  }
}
